module.exports = __webpack_public_path__ + "img/paneles_old.22b046f6.png";